import { LitElement, css, html, unsafeHTML } from 'lit'

export class DzRating extends LitElement {

    static get properties() {
        return {
          interactive: { type: Boolean },
          maxValue: { type: Number },
          value: { type: Number, reflect: true }
        }
    }

     updated() {
        for (let child of this.renderRoot.children) {
            if (this.interactive) {
                child.onclick = (evt) => {
                    this.value = evt.target.dataset.value
                }
            }
        }
    }

    render() {
        let newChildren = []
        for (let n = 0; n < this.maxValue; n++) {
            let node = this.children[n < this.value? 0 : 1].cloneNode(true)
            node.dataset.value = n + 1
            node.setAttribute("part", "item")
            newChildren.push(unsafeHTML(node.outerHTML))
        }
        return html`${newChildren}`
    }

    static get styles() {
        return css`
            :host {
                display: flex;
            }

            :host > * {
                cursor: pointer;
            }
        `
    }
}

window.customElements.define('dz-rating', DzRating)